import { createApiHook } from '../hooks';
import { unipFunnelApiFactory } from './unipFunnelApiFactory';

export const useUnipFunnelApi = createApiHook(unipFunnelApiFactory);
